// extracted by mini-css-extract-plugin
export default {"container":"np-z","brandName":"op-z","productName":"pp-z","productNamePdpEnhancements":"qp-z","breakLongProductName":"rp-z"};